export default __webpack_public_path__ + "static/media/mes-points-de-vente.6746911d.svg";